const errors = [
    {
        path: '/error',
        name: 'Error',
        component: () => import('@/views/errors/error'),
        children: [],
        meta: {
            requiresAuth: false
        },
    },
    {
        path: '*',
        name: '404',
        component: () => import('@/views/errors/404'),
        children: [],
        meta: {
            requiresAuth: false
        },
    }
]

export default errors